/* Mavaro — fiche produit : galerie, variantes, ajout au panier */
(function () {
  'use strict';

  /* ---------- Galerie ---------- */
  if (!customElements.get('mavt-gallery')) {
    class MavtGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mavt-gallery__slides');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.thumbs = Array.from(this.querySelectorAll('.mavt-gallery__thumb'));
        this.dots = Array.from(this.querySelectorAll('.mavt-dot'));
        this.counter = this.querySelector('[data-current]');
        this.prev = this.querySelector('.mavt-gallery__arrow--prev');
        this.next = this.querySelector('.mavt-gallery__arrow--next');
        this.index = 0;

        this.querySelectorAll('[data-go]').forEach((el) =>
          el.addEventListener('click', () => this.go(parseInt(el.dataset.go, 10)))
        );
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
        this.thumbList = this.querySelector('.mavt-gallery__thumbs');
        this.querySelectorAll('[data-thumbs-dir]').forEach((b) => b.addEventListener('click', () => {
          if (!this.thumbList) return;
          const li = this.thumbList.children[0];
          const step = li ? li.getBoundingClientRect().width + 7 : 60;
          this.thumbList.scrollBy({ left: parseInt(b.dataset.thumbsDir, 10) * step, behavior: 'smooth' });
        }));
        if (this.thumbList) {
          const upd = () => {
            const p = this.querySelector('[data-thumbs-dir="-1"]'), n = this.querySelector('[data-thumbs-dir="1"]');
            const l = this.thumbList;
            if (p) p.disabled = l.scrollLeft <= 2;
            if (n) n.disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 2;
          };
          this.thumbList.addEventListener('scroll', upd, { passive: true });
          window.addEventListener('resize', upd, { passive: true });
          setTimeout(upd, 50);
        }
        if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));

        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) this.setActive(i, false);
          });
        }, { passive: true });

        this.setActive(0, false);
      }

      go(i, smooth = true) {
        if (!this.slides.length) return;
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.track.scrollTo({ left: this.track.clientWidth * i, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(i, true);
      }

      goToMedia(mediaId) {
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i > -1) this.go(i);
      }

      setActive(i, scrollThumb) {
        const old = this.slides[this.index];
        this.index = i;
        this.slides.forEach((s, n) => (n === i ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true')));
        this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        this.dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (this.counter) this.counter.textContent = i + 1;
        if (this.prev) this.prev.disabled = i === 0;
        if (this.next) this.next.disabled = i === this.slides.length - 1;
        if (old && old !== this.slides[i]) {
          old.querySelectorAll('video').forEach((v) => { if (!v.muted) v.pause(); });
        }
        if (scrollThumb && this.thumbs[i]) {
          const list = this.thumbs[i].closest('.mavt-gallery__thumbs');
          const li = this.thumbs[i].parentElement;
          if (list && li) list.scrollTo({ left: li.offsetLeft - list.clientWidth / 2 + li.clientWidth / 2, behavior: 'smooth' });
        }
      }
    }
    customElements.define('mavt-gallery', MavtGallery);
  }

  /* ---------- Sélecteur de variantes ---------- */
  if (!customElements.get('mavt-variant-picker')) {
    class MavtVariantPicker extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.mavt-product');
        const json = this.section && this.section.querySelector('[data-mavt-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.addEventListener('change', () => this.onChange());
        this.markAvailability();
      }
      selected() {
        return Array.from(this.querySelectorAll('fieldset')).map((fs) => {
          const c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      onChange() {
        const opts = this.selected();
        const variant = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
        this.querySelectorAll('fieldset').forEach((fs, i) => {
          const out = fs.querySelector('[data-mavt-option-value]');
          if (out) out.textContent = opts[i];
        });
        this.markAvailability();
        if (!variant) return;
        this.section.querySelectorAll('[data-mavt-variant-input]').forEach((input) => {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
        updateButtons(this.section, variant);
        updatePrice(this.section, variant);
        if (variant.featured_media) {
          const g = this.section.querySelector('mavt-gallery');
          if (g && g.goToMedia) g.goToMedia(variant.featured_media.id);
        }
        document.dispatchEvent(new CustomEvent('mavt:variant:change', { detail: { variant, sectionId: this.dataset.section } }));
      }
      markAvailability() {
        const opts = this.selected();
        this.querySelectorAll('fieldset').forEach((fs, pos) => {
          fs.querySelectorAll('input').forEach((input) => {
            const test = opts.slice();
            test[pos] = input.value;
            const ok = this.variants.some((v) => v.available && v.options.every((o, i) => i > pos || o === test[i]));
            input.classList.toggle('is-unavailable', !ok);
          });
        });
      }
    }
    customElements.define('mavt-variant-picker', MavtVariantPicker);
  }

  function formatMoney(cents) {
    const fmt = (window.Shopify && window.Shopify.currency) ? null : null;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function updatePrice(section, v) {
    section.querySelectorAll('[data-mavt-price-inner]').forEach((el) => {
      const sale = el.querySelector('.mavt-price__sale');
      if (sale) sale.textContent = formatMoney(v.price);
      let cmp = el.querySelector('.mavt-price__compare');
      if (v.compare_at_price > v.price) {
        if (!cmp) { cmp = document.createElement('s'); cmp.className = 'mavt-price__compare'; sale.after(cmp); }
        cmp.textContent = formatMoney(v.compare_at_price);
      } else if (cmp) cmp.remove();
      const badge = el.querySelector('.mavt-badge');
      if (badge) {
        if (!v.available) { badge.className = 'mavt-badge mavt-badge--soldout'; badge.textContent = 'Épuisé'; badge.hidden = false; }
        else if (v.compare_at_price > v.price) { badge.className = 'mavt-badge mavt-badge--sale'; badge.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; badge.hidden = false; }
        else badge.hidden = true;
      }
    });
  }

  function updateButtons(section, v) {
    section.querySelectorAll('[data-mavt-add]').forEach((btn) => {
      btn.disabled = !v.available;
      const label = btn.querySelector('[data-mavt-add-label]');
      if (!label) return;
      if (!btn.dataset.label) btn.dataset.label = label.textContent.trim();
      label.textContent = v.available ? btn.dataset.label : 'Épuisé';
    });
  }

})();
